import { createFileRoute } from '@tanstack/react-router'

import { LABELS } from '@/constants/common/message.constants'
import { fetchMonthlyTask } from '@/features/monthly-task/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

export const Route = createFileRoute('/_protected/$tenantKey/')({
  loader: async ({
    abortController,
    params: { tenantKey },
    context: { auth }
  }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    return {
      authUser: auth.user,
      monthlyTasks: await fetchMonthlyTask(
        {
          tenantKey,
          dcId: selectedDcId
        },
        abortController.signal
      )
    }
  },
  meta: () => [
    {
      title: LABELS.DASHBOARD
    }
  ]
})
